module.exports = __webpack_public_path__ + "media/images/companyPage/mindful-ce77760eb24a3c84fb7588a51ccfc6d5.svg";